<script lang="ts" setup>
defineProps<{
  title?: string;
  subTitle?: string;
}>();
</script>
<template>
  <div class="auth-container">
    <div class="auth-content">
      <slot name="title">
        <h1 class="title">
          {{ title }}
        </h1>
      </slot>
      <slot name="sub-title">
        <p v-if="subTitle" class="sub-title">
          {{ subTitle }}
        </p>
      </slot>

      <div class="content">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.auth-container {
  background: #ffffff;
  /* Primary / Blue Dark / 15 */

  display: flex;
  flex: 1 1 auto;
  z-index: 1;
  overflow: auto;

  @media (min-width: 600px) {
    height: auto;
    margin: auto 25px;

    padding-top: 32px;
    padding-bottom: 47px;

    border: 1px solid var(--border-colour);
    box-sizing: border-box;
    box-shadow:
      0px 4px 6px rgba(63, 59, 59, 0.02),
      0px 2px 4px rgba(0, 0, 0, 0.06);
    border-radius: 8px;

    z-index: 1;
  }

  // set max-width and center with margin
  @media (min-width: 770px) {
    max-width: 720px;
    margin: auto;
  }

  .auth-content {
    display: flex;
    flex-direction: column;

    flex: 1 1 auto;

    margin: auto 24px;
    z-index: 1;

    @media (min-width: 600px) {
      margin: auto 116px;
    }

    h1.title {
      /* identical to box height, or 145% */
      font-family: Georgia;
      font-weight: 400;
      line-height: 150%;
      text-align: center;
      letter-spacing: 0.2px;

      color: var(--text-color);

      // margin-bottom: 3rem;

      @media (min-width: 600px) {
        font-size: 28px;
      }
    }

    p.sub-title {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 150%;
      /* or 171% */

      display: flex;
      align-items: center;
      letter-spacing: 0.2px;

      color: var(--text-color);

      // margin-bottom: 1rem;
      margin-bottom: 0;
    }

    > .content {
      margin-top: 1rem;
    }
  }
}
</style>
